// extracted by mini-css-extract-plugin
export default {"advertContainer":"C3f8u"};